import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { Exchange1cScreen } from '../features/exchange-1c/Exchange1cScreen'

/** /exchange-1c — кабинет дистрибьютора, мониторинг и управление 1С-обменом.
 *  Защищённый роут — wrapped в <RequireAuth>. Permission-gating внутри экрана
 *  (без permission view-sync-events показывается warning Banner).
 *
 *  Файл назван `exchange-1c.index.tsx`, а не `exchange-1c.tsx`, чтобы избежать
 *  превращения роута в parent-layout для соседних `exchange-1c.events.tsx`
 *  (full-search экран). Аналогично `orders.index.tsx` vs. `orders.$id.tsx`. */
export const Route = createFileRoute('/exchange-1c/')({
  component: Exchange1cRoute,
})

function Exchange1cRoute() {
  return (
    <RequireAuth>
      <Exchange1cScreen />
    </RequireAuth>
  )
}
